import RequesterV1 from "@/components/api/v1/requester.js";

export default {
  fetchProducers(organization_id) {
    return RequesterV1.get(
      `organization/process/packing/queries_to_harvested_batch/${organization_id}/fetch_producers`
    );
  },
  fetchAgroExporterProcesses(organization_id, harvest_proces_id) {
    return RequesterV1.get(
      `organization/process/packing/queries_to_harvested_batch/${organization_id}/fetch_agro_exporter_processes/${harvest_proces_id}`
    );
  },
  fetchCropTypes(organization_id, harvest_proces_id) {
    return RequesterV1.get(
      `organization/process/packing/queries_to_harvested_batch/${organization_id}/fetch_crop_types/${harvest_proces_id}`
    );
  },
  fetchCropHarPackages(organization_id, harvest_proces_id) {
    return RequesterV1.get(
      `organization/process/packing/queries_to_harvested_batch/${organization_id}/fetch_crop_har_packages/${harvest_proces_id}`
    );
  },
  fetchHarvestTeams(organization_id, harvest_proces_id) {
    return RequesterV1.get(
      `organization/process/packing/queries_to_harvested_batch/${organization_id}/fetch_harvest_teams/${harvest_proces_id}`
    );
  },
  fetchPackingLines(organization_id, harvest_proces_id) {
    return RequesterV1.get(
      `organization/process/packing/queries_to_harvested_batch/${organization_id}/fetch_packing_lines/${harvest_proces_id}`
    );
  },
  fetchCropFields(organization_id, producer_id) {
    return RequesterV1.get(
      `organization/process/packing/queries_to_harvested_batch/${organization_id}/fetch_crop_fields/${producer_id}`
    );
  },
  fetchOrganizationCropField(organization_id, crop_field_id) {
    return RequesterV1.get(
      `organization/process/packing/queries_to_harvested_batch/${organization_id}/fetch_organization_crop_field/${crop_field_id}`
    );
  }
};
